angular.module('SpidApp')

.constant('PrixTrancheAffranchissementZoneAdapterConfig', {
  name : 'PrixTrancheAffranchissementZone',
  fields : [
    {
    	local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'id_zone',
    	distant : 'id_zone'
    }, {
    	local   : 'tranche_inferieure',
    	distant : 'tranche_inferieure'
    }, {
    	local   : 'tranche_superieure',
    	distant : 'tranche_superieure'
    }, {
    	local   : 'prix',
    	distant : 'prix'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})
